import type { AxiosRequestConfig } from 'axios';

import axiosInstance from 'src/lib/axios';

/**
 * API client enxuto: retorna diretamente o payload
 * e delega exibição de erros ao interceptor do axiosInstance.
 */
export const api = {
  get: <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
    axiosInstance.get<T>(url, config).then((res) => res.data),

  post: <T, U = any>(url: string, body: U, config?: AxiosRequestConfig): Promise<T> =>
    axiosInstance.post<T>(url, body, config).then((res) => res.data),

  put: <T, U = any>(url: string, body: U, config?: AxiosRequestConfig): Promise<T> =>
    axiosInstance.put<T>(url, body, config).then((res) => res.data),

  patch: <T, U = any>(url: string, body: U, config?: AxiosRequestConfig): Promise<T> =>
    axiosInstance.patch<T>(url, body, config).then((res) => res.data),

  delete: <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
    axiosInstance.delete<T>(url, config).then((res) => res.data),
};
